import React, { FC, ReactNode } from 'react'

import styled, { css } from 'styled-components'

import { definitions as search } from 'api/generated/search'
import { WithClassName } from 'common/types'
import { Colors } from 'common-constants/colors'

const TextFormatCss = css`
  font-weight: normal;
  color: ${Colors.specialGray};
`

export const TextFormat = styled.span`
  font-size: 12px;
  ${TextFormatCss};
`

export const HitListTextFormat = styled.span`
  ${TextFormatCss};
`

/**
 * Формат API6
 * При использовании GraphQL нужно использовать SpaceTimeLocationRelationView
 * @param className
 * @param statuses
 * @constructor
 */
export const SpaceTimeLocation: FC<
  {
    statuses?: search['ProfileStatuses']
    location?: ReactNode
  } & WithClassName
> = ({ className, statuses, location }) => {
  if (statuses?.spaceTimeLocation?.isOn) {
    return (
      <TextFormat className={className} data-name="space-time-location-text">
        {location || statuses.spaceTimeLocation.text}
      </TextFormat>
    )
  }
  return null
}

export const SpaceTimeLocationRelationHitListView: FC<{ text: ReactNode }> = ({
  text,
}) => {
  if (text) {
    return (
      <HitListTextFormat data-name="space-time-location-text">
        {text}
      </HitListTextFormat>
    )
  }
  return null
}

export const SpaceTimeLocationNotification = ({ spaceTimeLocation }: any) => {
  if (spaceTimeLocation) {
    return (
      <TextFormat data-name="space-time-location-text">
        {spaceTimeLocation}
      </TextFormat>
    )
  }

  return null
}
